import script from "./share.vue?vue&type=script&setup=true&lang=js"
export * from "./share.vue?vue&type=script&setup=true&lang=js"

import "./share.vue?vue&type=style&index=0&id=0e0a4652&lang=scss"
import "./share.vue?vue&type=style&index=1&id=0e0a4652&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0a4652"]])

export default __exports__